import { render } from "./RecordRules.vue?vue&type=template&id=622c4c9f"
import script from "./RecordRules.vue?vue&type=script&lang=js"
export * from "./RecordRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/alangray/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__